function initEngravingModals(root = document) {
  root.querySelectorAll('[data-engraving-modal]').forEach((modal) => {
    if (modal.dataset.engravingInitialized === 'true') return;

    const input = modal.querySelector('[data-engraving-input]');

    const previewText = modal.querySelector('[data-preview-text]');
    const textPath = modal.querySelector('[data-preview-text-path]');

    const outerText = modal.querySelector('.engraving-preview__text--outer');
    const middleText = modal.querySelector('.engraving-preview__text--middle');
    const coreText = modal.querySelector('.engraving-preview__text--core');

    const outerTextPath = modal.querySelector('[data-preview-text-path-outer]');
    const middleTextPath = modal.querySelector('[data-preview-text-path-middle]');

    const path = modal.querySelector('[data-engraving-path]');
    const engravingGroup = modal.querySelector('[data-engraving-group]');

    const counter = modal.querySelector('[data-character-count]');

    const fontButtons = modal.querySelectorAll('[data-engraving-font]');

    const stage = modal.querySelector('[data-engraving-stage]');
    const zoomInButton = modal.querySelector('[data-zoom-in]');
    const zoomOutButton = modal.querySelector('[data-zoom-out]');
    const zoomResetButton = modal.querySelector('[data-zoom-reset]');

    if (!input || !previewText || !textPath || !path || !engravingGroup) {
      return;
    }

    /* ----------------------------------
       VÆRDIER (sat fast i engraving-modal.liquid)
    ---------------------------------- */

    const centerX = parseFloat(modal.dataset.centerX);
    const centerY = parseFloat(modal.dataset.centerY);
    const radius = parseFloat(modal.dataset.radius);
    const centerAngle = parseFloat(modal.dataset.centerAngle);
    const rotation = parseFloat(modal.dataset.rotation);
    const fontSize = parseFloat(modal.dataset.fontSize);
    const arcDegrees = parseFloat(modal.dataset.arcDegrees);

    if (
      Number.isNaN(centerX) ||
      Number.isNaN(centerY) ||
      Number.isNaN(radius) ||
      Number.isNaN(centerAngle) ||
      Number.isNaN(rotation) ||
      Number.isNaN(fontSize) ||
      Number.isNaN(arcDegrees)
    ) {
      console.warn('Engraving preview: missing data-values in engraving-modal.liquid');
      return;
    }

    modal.dataset.engravingInitialized = 'true';

    /* ----------------------------------
       ARC PATH
    ---------------------------------- */

    const toRadians = (degrees) => (degrees * Math.PI) / 180;

    const startAngle = centerAngle - arcDegrees / 2;
    const endAngle = centerAngle + arcDegrees / 2;

    const startX = centerX + radius * Math.cos(toRadians(startAngle));
    const startY = centerY + radius * Math.sin(toRadians(startAngle));

    const endX = centerX + radius * Math.cos(toRadians(endAngle));
    const endY = centerY + radius * Math.sin(toRadians(endAngle));

    path.setAttribute('d', `M ${endX} ${endY} A ${radius} ${radius} 0 0 0 ${startX} ${startY}`);

    engravingGroup.setAttribute('transform', `rotate(${rotation} ${centerX} ${centerY})`);

    /* ----------------------------------
       FONT SIZE
    ---------------------------------- */

    const setFontSize = (size) => {
      if (coreText) coreText.style.fontSize = `${size}px`;
      if (middleText) middleText.style.fontSize = `${size}px`;
      if (outerText) outerText.style.fontSize = `${size}px`;
    };

    setFontSize(fontSize);

    /* ----------------------------------
       UPDATE PREVIEW
    ---------------------------------- */

    const updatePreview = () => {
      const value = input.value;

      textPath.textContent = value;
      if (outerTextPath) outerTextPath.textContent = value;
      if (middleTextPath) middleTextPath.textContent = value;

      if (counter) counter.textContent = value.length;

      // Nulstil størrelsen før måling, så teksten kan vokse igen når der slettes tegn
      setFontSize(fontSize);

      requestAnimationFrame(() => {
        const pathLength = path.getTotalLength();
        const textLength = previewText.getComputedTextLength();
        const availableLength = pathLength * 0.9;

        if (textLength > availableLength && textLength > 0) {
          setFontSize(fontSize * (availableLength / textLength));
        }
      });
    };

    input.addEventListener('input', updatePreview);

    /* ----------------------------------
       FONT SELECTOR
    ---------------------------------- */

    const applyFont = (font) => {
      if (coreText) coreText.style.fontFamily = font;
      if (middleText) middleText.style.fontFamily = font;
      if (outerText) outerText.style.fontFamily = font;
    };

    fontButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const selectedFont = button.dataset.engravingFont;
        if (!selectedFont) return;

        fontButtons.forEach((item) => item.classList.remove('engraving-font--active'));
        button.classList.add('engraving-font--active');

        applyFont(selectedFont);

        // Forskellige fonte har forskellig bredde
        updatePreview();
      });
    });

    const initialFontButton = modal.querySelector('.engraving-font--active[data-engraving-font]');
    if (initialFontButton && initialFontButton.dataset.engravingFont) {
      applyFont(initialFontButton.dataset.engravingFont);
    }

    updatePreview();

       /* ----------------------------------
       ZOOM + TRÆK I BILLEDET
    ---------------------------------- */

    const preview = modal.querySelector('.engraving-preview');

    if (stage && preview) {
      const DEFAULT_ZOOM = window.matchMedia('(max-width: 749px)').matches ? 4 : 2.75;
      const MIN_ZOOM = 1;
      const MAX_ZOOM = 5;
      const ZOOM_STEP = 0.25;

      let zoom = DEFAULT_ZOOM;
      let panX = 0;
      let panY = 0;

      // Billedet må kun trækkes så langt, at kanten rammer kanten af feltet
      const clampPan = () => {
        const maxX = Math.max(0, (stage.offsetWidth * zoom - preview.clientWidth) / 2);
        const maxY = Math.max(0, (stage.offsetHeight * zoom - preview.clientHeight) / 2);
        panX = Math.min(maxX, Math.max(-maxX, panX));
        panY = Math.min(maxY, Math.max(-maxY, panY));
      };

      const render = () => {
        clampPan();
        stage.style.transform = `translate(${panX}px, ${panY}px) scale(${zoom})`;
        stage.dataset.zoom = zoom.toString();

        if (zoomResetButton) {
          zoomResetButton.textContent = `${Math.round(zoom * 100)}%`;
        }
      };

      render();

      if (zoomInButton) {
        zoomInButton.addEventListener('click', (event) => {
          event.preventDefault();
          zoom = Math.min(MAX_ZOOM, zoom + ZOOM_STEP);
          render();
        });
      }

      if (zoomOutButton) {
        zoomOutButton.addEventListener('click', (event) => {
          event.preventDefault();
          zoom = Math.max(MIN_ZOOM, zoom - ZOOM_STEP);
          render();
        });
      }

      if (zoomResetButton) {
        zoomResetButton.addEventListener('click', (event) => {
          event.preventDefault();
          zoom = DEFAULT_ZOOM;
          panX = 0;
          panY = 0;
          render();
        });
      }

      /* Træk med mus eller finger */

      let dragging = false;
      let startX = 0;
      let startY = 0;
      let startPanX = 0;
      let startPanY = 0;

      preview.addEventListener('pointerdown', (event) => {
        if (event.target.closest('.engraving-zoom')) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;

        dragging = true;
        startX = event.clientX;
        startY = event.clientY;
        startPanX = panX;
        startPanY = panY;

        preview.setPointerCapture(event.pointerId);
        preview.classList.add('engraving-preview--dragging');
      });

      preview.addEventListener('pointermove', (event) => {
        if (!dragging) return;

        panX = startPanX + (event.clientX - startX);
        panY = startPanY + (event.clientY - startY);
        render();
      });

      const endDrag = (event) => {
        if (!dragging) return;

        dragging = false;
        preview.classList.remove('engraving-preview--dragging');

        if (preview.hasPointerCapture(event.pointerId)) {
          preview.releasePointerCapture(event.pointerId);
        }
      };

      preview.addEventListener('pointerup', endDrag);
      preview.addEventListener('pointercancel', endDrag);

      // Hold billedet inden for kanten, hvis skærmen drejes eller ændrer størrelse
      window.addEventListener('resize', render);
    }
  });
}

/* ----------------------------------
   INITIALISE
---------------------------------- */

document.addEventListener('DOMContentLoaded', () => {
  initEngravingModals();
});

// Theme editor: genindlæs når sektionen opdateres
document.addEventListener('shopify:section:load', (event) => {
  initEngravingModals(event.target);
});